import { assign } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';

export const addToCartFailure = assign(
  (
    context: ProductBuilderMachineContext,
    event: ProductBuilderMachineEvent,
  ) => {
    console.log('Add to cart has failed');
    console.log(event);
    return context;
  },
);
